import React, { useContext, useState } from "react";
import { FormattedMessage } from 'react-intl';
import avatar from './../../utils/images/avatar_fluincr.png';

import { getConvertCurrency } from "../../api/exchangeApi";
import { CurrencyContext } from "../../context/currencyContext";
import { useEffect } from "react";
import ItemCollaboration from "./ItemColaboration";
import { formatNumber } from "../../services/generalSevices";


export default function CollaborationCart({ collaboration, setEditCollaborationData, setShowEditCollaboration, handlerDeleteCollaboration }) {

    const { currency } = useContext(CurrencyContext);
    const auxCurrency = currency.symbol;

    //const [totalPrice, setTotalPrice] = useState(null);
    const [totalPrice, setTotalPrice] = useState(collaboration.totalPrice);
    const [giftValue, setGiftValue] = useState(null);
    const typeContent = [];

    useEffect(() => {
        getConvertCurrency({ amount: collaboration.totalPrice }).then((response) => {
            //setTotalPrice(response[auxCurrency].toFixed(0))
            setTotalPrice(response[auxCurrency].toFixed(2))
        })

        if (collaboration.giftValue !== null) {
            getConvertCurrency({ amount: collaboration.giftValue }).then((response) => {
                //setGiftValue(response[auxCurrency].toFixed(0))
                setGiftValue(response[auxCurrency].toFixed(2))
            })
        }

    }, [currency])


    return (<div className="item">
        <div className="collaboration">
            <div className="influencerImage" style={{ backgroundImage: `url(${(collaboration?.influincr?.imageProfile !== null) ? collaboration?.influincr?.imageProfile : avatar})` }}>
                <div className="influencerName"><p>{collaboration?.influincr?.givenName} {collaboration?.influincr?.familyName}</p></div>
            </div>
            <div className="collaborationData">
                <table className="collaborationDetails">
                    <tr>
                        <th className="firstColumn"><FormattedMessage id="cart_text_5" defaultMessage="Colaboración" /></th>
                        <th className="firstColumn">{currency.symbol} ${formatNumber(totalPrice)}</th>
                    </tr>

                    {collaboration.item.map((item) => {
                        if (!typeContent.includes(JSON.parse(item.title).name)) {
                            typeContent.push(JSON.parse(item.title).name)
                            return (
                                <ItemCollaboration item={item} key={item.id} />
                            )
                        }

                    })}
                    {(collaboration?.gift) && (<tr>
                        <td ><FormattedMessage id="cart_text_12" defaultMessage="Servicio/ producto gratis" /></td>
                        <td className="freeProduct"><span className="lessIcon">- </span>${formatNumber(giftValue)}</td>
                    </tr>)}

                </table>
                <p className="editCollaboration" onClick={() => {
                    setEditCollaborationData(collaboration)
                    setShowEditCollaboration(true);
                }}><FormattedMessage id="cart_text_7" defaultMessage="Editar colaboración" /></p>

                <p className="deleteCollaboration" on onClick={() => {
                    handlerDeleteCollaboration(collaboration.id)
                }}><FormattedMessage id="cart_text_13" defaultMessage="Eliminar colaboración" /></p>
            </div>


        </div>

        <div className="productImage" style={{ backgroundImage: `url(${(collaboration?.product?.image !== null) ? collaboration?.product?.image : avatar})` }}>
            <div className="productName">
                <p>{collaboration.product.name}</p>
            </div>
        </div>

    </div>)
}